// extracted by mini-css-extract-plugin
export default {"root":"Anchors_root__PvSG7","anchor":"Anchors_anchor__OpZQQ"};